module.exports = __webpack_public_path__ + "img/logo.13a3a943.png";